import { View } from "../view";
import { EventSource } from "../event-source";
import * as Dom from '../helpers/dom';
import ViewRendeder from "../view/renderer";
import { ActionBarItem, ActionBarItemConstructor } from "./item";
import { BaseApp } from "../app";

/**
 * Represents a configurable collection of items that either
 * justify to the left or the right edge of the screen.
 */
export default class ActionBar
{
    private app: BaseApp;
    private containerElement: HTMLElement;
    private groupContainers: {[group: string]: HTMLElement};
    private toggleButton: HTMLButtonElement;
    private items: ActionBarItem[];

    constructor(app: BaseApp)
    {
        this.app = app;
        this.containerElement = <HTMLElement>document.querySelector('[data-actionbar-container]');
        this.toggleButton = <HTMLButtonElement>this.containerElement.querySelector('.toggle');
        this.groupContainers = {};
        this.items = [];

        this.toggleButton.addEventListener('click', e =>
        {
            this.containerElement.classList.toggle('expanded');
        });
    }

    /**
     * Gets the container element designated for the group.
     * @param group Name of the group.
     */
    private getGroupContainer(group: string): HTMLElement
    {
        if (this.groupContainers[group] === undefined)
        {
            this.groupContainers[group] = <HTMLElement>this.containerElement.querySelector(`.items > .${group}`);
        }

        return this.groupContainers[group];
    }

    /**
     * Adds a new action bar item to the action bar.
     * @param actionBarItemConstructor Type of the item to add.
     */
    public add<T extends ActionBarItem>(actionBarItemConstructor: ActionBarItemConstructor): Promise<T>
    {
        let view = new actionBarItemConstructor(this);
        this.items.push(view);
        return new Promise<T>((resolve, reject) => 
        {
            this.app.renderPartialView(view, this.getGroupContainer(view.group)).then(() => 
            {
                resolve(<T>view);
            });
        });
    }

    /**
     * Probably not going to be publicly available. Item instances should remove themselves if
     * required.
     * @param actionBarItemConstructor
     */    
    private remove(actionBarItemConstructor: ActionBarItemConstructor): PromiseLike<void>
    {
        let promises: PromiseLike<void>[] = [];
        for(let item of this.items)
        {
            if (item instanceof actionBarItemConstructor)
            {
                promises.push(item.remove());
            }
        }

        return new Promise((resolve, reject) =>
        {
            if (promises.length === 0)
            {
                resolve();
            }
            else
            {
                Promise.all(promises).then(() => resolve);
            }
        });
    }

    public collapse()
    {
        this.containerElement.classList.remove('expanded');
    }
}

